"use strict";

class ActivityLogController {

    constructor($scope, SSHttpService, SSUtilService, SSAlertService, SSUserService) {
        const self = this;

        self.$scope = $scope;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;

        self.ACTIONS = {};
        self.ACTIONS[1] = "Created";
        self.ACTIONS[2] = "Updated";
        self.ACTIONS[3] = "Deleted";

        self.STYLE_COLOR = {};
        self.STYLE_COLOR[1] = "green";
        self.STYLE_COLOR[2] = "blue";
        self.STYLE_COLOR[3] = "red";

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        let self = this;

        self.filter = {
            model: 'Property',
            model_id: 1,
        };
        self.activityLogs = [];

        // WEB-4851: records per call (sent as `limit`; the API default is also 20).
        self.LIMITS = [20, 50, 100, 500, 1000];
        self.limit = 20;
        self.fetchedLimit = self.limit;

        //self.getUsers();
        //self.getModels();
        //self.getActivityLogs();
    }

    getUsers() {
        let self = this;

        self.users = [];

        let url = 'sec/super/users/names';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.users = response.data.users;
        });
    }

    getModels() {
        let self = this;

        self.models = [];

        let url = 'sec/super/activitylog/models';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.models = response.data.models;
        });
    }

    /**
     * Fetches the Database Logs for the current filters.
     *
     * @remarks WEB-4851: From / To are converted from the picker's DD/MM/YYYY HH:mm:ss to the
     *          API's YYYY-MM-DD HH:mm:ss (UTC, as listed) and the chosen record limit is sent.
     *          A copy of the filter is sent because SSHttpService adds device_uuid to the
     *          params object it is given.
     */
    getActivityLogs() {
        let self = this;

        let fromDate = logDateTimeToServer(self.filter.from_date);
        let toDate = logDateTimeToServer(self.filter.to_date);
        if (fromDate === null || toDate === null) {
            self.SSAlertService.danger('Invalid date', 'Enter From / To Date as DD/MM/YYYY HH:mm:ss, or pick it from the calendar.');
            return;
        }

        let url = 'sec/super/activitylog';
        let params = angular.extend({}, self.filter, {
            from_date: fromDate,
            to_date: toDate,
            limit: self.limit,
        });

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.clear();

            self.activityLogs = response.data.activity_logs;
            self.fetchedLimit = params.limit;
        });
    }

    showChangeset(id) {
        let div = $("#divChangeset" + id);
        if (div.is(":visible")) {
            div.slideUp(400);
        } else {
            div.slideDown(400);
        }
    }

    getUserName(userId) {
        const self = this;

        let userName = null;
        if (userId && self.users) {
            userName = self.users[userId];
        }

        return userName ? userName : "Unknown";
    }

}

ActivityLogController.$inject = ['$scope', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSUserService'];
app.controller('ActivityLogController', ActivityLogController);

/**
 * WEB-4851 - Converts a From / To filter value (DD/MM/YYYY HH:mm:ss as the picker writes it;
 * HH:mm or a bare date are accepted when typed) to the API's format. A bare date is sent
 * date-only so the API applies whole-day bounds.
 *
 * @param {string} value UI filter value.
 * @returns {string|undefined|null} YYYY-MM-DD HH:mm:ss / YYYY-MM-DD; undefined when empty
 *          (no filter); null when it cannot be parsed.
 */
function logDateTimeToServer(value) {
    if (!value || !String(value).trim()) {
        return;
    }

    value = String(value).trim();
    let hasTime = /\d{1,2}:\d{2}/.test(value);
    let date = moment(value, hasTime ? ['D/M/YYYY H:m:s', 'D/M/YYYY H:m'] : 'D/M/YYYY', true);
    if (!date.isValid()) {
        return null;
    }

    return date.format(hasTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD');
}

/**
 * WEB-4851 - jQuery-UI date + time picker (hour / minute / second) for the From / To filters.
 * Use as log-datetimepicker="start" or log-datetimepicker="end"; the "end" picker opens at
 * 23:59:59 so picking just a day still covers that whole day.
 */
app.directive("logDatetimepicker", function () {
    function link(scope, element, attrs) {
        let isEnd = attrs.logDatetimepicker === 'end';

        element.datetimepicker({
            dateFormat: "dd/mm/yy",
            timeFormat: "HH:mm:ss",
            changeMonth: true,
            changeYear: true,
            controlType: "select",
            oneLine: true,
            showSecond: true,
            hour: isEnd ? 23 : 0,
            minute: isEnd ? 59 : 0,
            second: isEnd ? 59 : 0,
        });
    }

    return {
        require: 'ngModel',
        link: link
    };
});

